<template>
  <f7-page id="sample-page" name="sample-page">
      <f7-navbar class="no-border">
        <f7-nav-left>
          <f7-link class="back-button" @click="test">
            <i class="f7-icons">chevron_left</i>
          </f7-link>
        </f7-nav-left>
      </f7-navbar>

      <div class="block">
        <div class="text-align-right mb-xl">
          <span>Test Change Theme</span>
          <f7-toggle @change="changeTheme" class="ml-sm"></f7-toggle>
        </div>

        <!-- LANG -->
        <!--<div class="row">
          <div class="col wandr-paragraph-1">LANGUAGE</div>
          <div class="col text-align-right"><langSwitch /></div>
        </div>-->
        <!-- END OF LANG -->

        <!-- FORM -->
        <div class="wandr-paragraph-1">FORM</div>
        <div>
          <f7-list class="form-group" style="">
            <f7-list-input
              input-id      ="fullname"
              name          ="fullname"
              type          ="text"
              class         =""
              placeholder   ="Enter your fullname"
              label         ="Full name"
              autocomplete  ="off"
              :value        ="fullname"
              @input        ="fullname=$event.target.value"
              outline
              floating-label
              required
              validate
            >
            
            </f7-list-input>

            <f7-list-input
              input-id      ="fullname2"
              name          ="fullname2"
              type          ="text"
              class         =""
              placeholder   ="Enter your fullname"
              label         ="Disabled Field"
              value         ="John Doe"
              autocomplete  ="off"
              outline
              floating-label
              required
              validate
              disabled
            >
            
            </f7-list-input>

            <f7-list-input
              input-id      ="email"
              name          ="email"
              type          ="email"
              class         =""
              placeholder   ="Enter your email"
              label         ="Email"
              @input        ="email = $event.target.value;validateInput($event.target);"
              autocomplete  ="off"
              outline
              floating-label
              required
            >
            
            </f7-list-input>
          
            <f7-list-input
              input-id      ="password"
              name          ="password"
              type          ="password"
              class         =""
              placeholder   ="Enter your password"
              inputmode     ="numeric"
              maxlength     ="8"
              minlength     ="8" 
              size          ="8"
              label         ="Password"
              outline
              floating-label
              required
              validate
            >
              <!--<div slot="content-end" class="bg-color-primary color-theme-yellow" style="display:flex; align-self:center">
                <img :src="require('@/assets/img/icon/icon-eye.svg')" class="">
              </div>-->
            </f7-list-input>

            <!-- Dropdown : down -->
            <f7-list-input
                input-id     ="paymentPurpose"
                id           ="paymentPurposeInput"
                name         ="paymentPurpose"
                class        ="clickable-row use-chevron"

                v-show       ="true"
                :label       ="$t('beneficiary-payment-purpose')"
                :placeholder ="$t('beneficiary-select-payment-purpose')"
                :value       ="paymentPurpose"

                autocomplete ="off"
                outline
                floating-label
            >
                <f7-link popover-open=".popover-dropdown-tx-purpose" slot="content-start" class="clickable-item"></f7-link>
            </f7-list-input>

            <f7-popover id="dropdownPaymentPurpose" class="popover-dropdown-tx-purpose dropdown-default dropdown beneficiary" :backdrop="true">
              <f7-list>
                  <f7-list-item popover-close link="#"
                  v-for="item in paymentPurposeList"
                  :key="item.id"
                  selected=""
                  @click="setInputState('paymentPurpose',$t('regis-mobileNum-rule'))">
                    {{item.name}}
                  </f7-list-item>
              </f7-list>
            </f7-popover>

            <f7-list-input
              input-id     ="paymentMethod"
              id           ="paymentMethod"
              name         ="paymentMethod"
              class        ="clickable-row use-chevron"
              label        ="Payment Method"
              placeholder  ="Select Payment Method"
              :value       ="paymentMethod"
              outline
              floating-label
              validate
            >
              <div class="clickable-item" @click="openPMSmartSelect" slot="root-start"></div>
            </f7-list-input>

            <li v-show="false">
              <a href="#" id="pm-smart-select" class="item-link" >
                <select @change="changePM($event.target.value);" v-model="paymentMethodId">
                  <option v-for="pm in pmList" :key="pm.id" :value="pm.id" :selected="pm.id == paymentMethodId" :data-option-image="require('@/assets/img/flags/flag_rect_'+currentHostId+'.png')">
                    {{pm.name}}
                  </option>
                </select>
              </a>
            </li>
            <!-- end of dropdown : down -->

            <!-- Dropdown Without Chevron -->
            <f7-list-input
              input-id     ="dropdown1"
              name         ="dropdown1"
              class        ="clickable-row use-chevron"
              label        ="Dropdown Without Chevron"
              placeholder  ="Select..."
              :value       ="paymentPurpose"
              outline
              floating-label
              validate
              readonly
            >
              <f7-link popover-open=".popover-dropdown-1" slot="content-start" class="clickable-item"></f7-link>
            </f7-list-input>

            <f7-popover class="popover-dropdown-1 dropdown-default dropdown" :backdrop="true">
              <f7-list>
                  <f7-list-item popover-close link="#"
                  v-for="item in paymentPurposeList"
                  :key="item.id"
                  selected=""
                  @click="changePurpose(item.id);">
                    {{item.name}}
                  </f7-list-item>
              </f7-list>
            </f7-popover>
            <!-- end of dropdown default -->

            <!-- Dropdown with chevron -->
            <f7-list-input
              input-id     ="dropdown2"
              name         ="dropdown2"
              class        ="clickable-row use-chevron"
              label        ="Dropdown - With Chevron"
              placeholder  ="Select..."
              outline
              floating-label
              validate
              readonly
            >
              <f7-link popover-open=".popover-dropdown-2" slot="content-start" class="clickable-item"></f7-link>
            </f7-list-input>

            <f7-popover class="popover-dropdown-2 use-chevron dropdown" :backdrop="true">
              <f7-list>
                  <f7-list-item popover-close link="#" @click="test">Item 1</f7-list-item>
                  <f7-list-item popover-close link="#" @click="test">Item 2</f7-list-item>
                  <f7-list-item popover-close link="#" @click="test">Item 3</f7-list-item>
                  <f7-list-item popover-close link="#" @click="test">Item 4</f7-list-item>
              </f7-list>
            </f7-popover>
            <!-- end of dropdown with chevron -->

            <!-- Dropdown with image 1 -->
            <f7-list-input
              input-id     ="dropdown3"
              name         ="dropdown3"
              class        ="clickable-row use-chevron"
              label        ="Dropdown - With Image 1"
              placeholder  ="Select"
              outline
              floating-label
              validate
              readonly
            >
              <f7-link popover-open=".popover-dropdown-3" slot="content-start" class="clickable-item">
              </f7-link>
            </f7-list-input>

            <f7-popover class="popover-dropdown-3 dropdown-with-image-1 dropdown" :backdrop="true">
              <f7-list>
                  <f7-list-item popover-close link="#" @click="test" class="">
                    <div class="row">
                      Item 1
                      <img :src="require('@/assets/img/paymentmethod/pm_2.png')" class="ml-sm"/>
                    </div>
                  </f7-list-item>
                  <f7-list-item popover-close link="#" @click="test" class="">
                    <div class="row">
                      Item 2
                      <img :src="require('@/assets/img/paymentmethod/pm_9.png')" class="ml-sm"/>
                    </div>
                  </f7-list-item>
              </f7-list>
            </f7-popover>
            <!-- end of dropdown with image 1 -->

            <!-- Dropdown with image 2 -->
            <f7-list-input
              input-id     ="dropdown4"
              name         ="dropdown4"
              class        ="clickable-row use-chevron"
              label        ="Dropdown - With Image 2"
              placeholder  ="Select"
              outline
              floating-label
              validate
              readonly
            >
              <f7-link popover-open=".popover-dropdown-4" slot="content-start" class="clickable-item">
              </f7-link>
            </f7-list-input>

            <f7-popover class="popover-dropdown-4 dropdown-with-image-2 dropdown" vertical-position="bottom" :backdrop="true">
              <f7-list>
                  <f7-list-item popover-close link="#" @click="test" class="">
                    Item 1
                    <img :src="require('@/assets/img/flags/flag_circle_small_189.png')" class="ml-sm"/>
                  </f7-list-item>
                  <f7-list-item popover-close link="#" @click="test" class="">
                    Item 2
                    <img :src="require('@/assets/img/flags/flag_circle_small_44.png')" class="ml-sm"/>
                  </f7-list-item>
              </f7-list>
            </f7-popover>
            <!-- end of dropdown with image 2 -->

            <!-- new mobile no-->
            <f7-list-input
              input-id      ="mobileNo"
              name          ="mobileNo"
              type          ="tel"
              class         ="mobile-input"
              placeholder   =""
              :value        ="mobileNo"
              @input        ="mobileNo = $event.target.value;"
              label         ="Mobile Telephone (Optional)"
              autocomplete  ="off"
              pattern       ="[0-9]*"
              inputmode     ="decimal"
              floating-label
              outline
              validate
            >
              <f7-link popover-open=".popover-mobile-no" slot="content-start" class="flag-with-chevron">
                <img :src="getFlagImg(currentHomeId)" />
                  {{ "+65" }}
              </f7-link>              
            </f7-list-input>

            <f7-popover class="popover-mobile-no mobile-country-code" :backdrop="true">
              <f7-list>
                  <f7-list-item popover-close link="#"
                  v-for="item in mobileCountryList"
                  :key="item.id"
                  selected="189"
                  @click="test">
                    <img :src="getFlagImg(item.id)" class="mr-sm"/>{{item.idd}}
                  </f7-list-item>
              </f7-list>
            </f7-popover>      
            <!-- end of new mobile no-->

            <!-- new mobile no 2-->
            <f7-list-input
              input-id      ="mobileNo2"
              id            ="mobileNo2Input"
              name          ="mobileNo2"
              type          ="tel"
              class         ="mobile-input"
              placeholder   =""
              value         ="876472364"
              label         ="Mobile Telephone (Optional)"
              autocomplete  ="off"
              pattern       ="[0-9]*"
              inputmode     ="decimal"
              floating-label
              outline
              validate
            >
              <f7-link id="mobileNo2Link" popover-open=".popover-mobile-no-2" slot="content-start" class="flag-with-chevron">
                <img :src="getFlagImg(currentHomeId)" />
                  {{ "+65" }}
              </f7-link>     
            </f7-list-input>

            <f7-popover id="dropdownCountryCode" class="popover-mobile-no-2 mobile-country-code-2 sample" :backdrop="true">
            <f7-list class="country-code-container">
              <f7-list-item popover-close link="#"
                v-for="item in mobileCountryList"
                :key="item.id"
                selected="189"
                class=""
                @click="test">
                  <div class="d-flex justtify-content-start">
                    <img :src="getFlagImg(item.id)" class="mr-sm"/>
                    <span class="mr-sm item-title">{{item.name}}</span>{{item.idd}}
                  </div>
                </f7-list-item>
            </f7-list>

            <f7-searchbar @input="searchBarInput" search-container=".country-code-container" search-in=".item-title" placeholder="country name" id="bene-search-bar"></f7-searchbar>
            </f7-popover>      
            <!-- end of new mobile no 2-->

            <!-- Date field -->
            <f7-list-input
              label="Expire Date (MM/YY)"
              type="datepicker"
              value=""
              placeholder="MM/YY"
              :calendar-params="{dateFormat: 'mm/yy', closeOnSelect: true, openIn: 'popover'}"
              class="calendar"
              clear-button
              outline
              floating-label
              validate
              required
            >
              
            </f7-list-input>
            <!-- End of date field-->

            <!-- Dropdown With Autocomplete -->
            <!--<li class="item-content item-input">
              <div class="item-inner">
                <div class="item-title item-label">Dropdown With Autocomplete</div>
                <div class="item-input-wrap bg-color-pink">
                  <input id="autocomplete-dropdown-all" type="text" placeholder="Type for searching" />
                </div>
              </div>
            </li>-->

            <f7-list-input
              input-id      ="autocomplete-dropdown"
              name          ="autocomplete-dropdown"
              type          ="text"
              class         =""
              placeholder   ="Type for searching"
              label         ="Autocomplete"
              autocomplete  ="off"
              outline
              floating-label
              required
              validate
            >
            
            </f7-list-input>

            <f7-list-input
              input-id      ="autocomplete-dropdown-all"
              name          ="autocomplete-dropdown-all"
              type          ="text"
              class         =""
              placeholder   ="Type for searching"
              label         ="Autocomplete All Values"
              autocomplete  ="off"
              outline
              floating-label
              required
              validate
            >
            
            </f7-list-input>

          </f7-list>

          <!-- input radio -->
          <f7-list class="form-group">
            <f7-block-title class="item-title item-label">Receiver Type</f7-block-title>

            <f7-list-item radio
              input-id     ="radioReceiverType"
              name         ="radioReceiverType"
              value        ="1"
              title        ="Individual"
            >
            </f7-list-item>

            <f7-list-item radio
              input-id     ="radioReceiverType"
              name         ="radioReceiverType"
              value        ="2"
              title        ="Business"
            >
              <div slot="root-end" class="mt-sm error-message" v-show="true">Radio Error Message</div>
            </f7-list-item>
          </f7-list>
          <!-- end of input radio -->

          <!-- amount field -->
          <div class="card card-20">
            <f7-list class="form-group">
              <f7-list-input
                input-id      ="hostAmount"
                name          ="hostAmount"
                type          ="text"
                class         ="amount"
                placeholder   =""
                value         ="1"
                label         ="You Send"
                autocomplete  ="off"
                pattern       ="[0-9]*"
                inputmode     ="decimal"
                outline
                floating-label
                required
                validate
              >
                <div slot="media" class="currency-code">
                  <img :src="require('@/assets/img/flags/flag_rect_'+currentHostId+'.png')" />
                  {{hostCurrCode}}
                </div>             
              </f7-list-input>

              <f7-list-input
                input-id      ="homeAmount"
                name          ="homeAmount"
                type          ="text"
                class         ="amount"
                placeholder   =""
                value         =""
                label         ="Recipient Receives"
                autocomplete  ="off"
                pattern       ="[0-9]*"
                inputmode     ="decimal"
                outline
                floating-label
                required
                validate
              >
                <f7-link popover-open=".popover-home-curr" class="row popover-fx-currency" slot="media">
                  <div class="currency-code">
                    <img :src="require('@/assets/img/flags/flag_rect_'+currentHomeId+'.png')"  />
                    {{homeCurrCode}}
                    <i class="f7-icons">chevron_down</i>
                  </div>
                </f7-link>              
              </f7-list-input>

              <f7-popover class="popover-home-curr popover-fx-currency" :backdrop="false">
                <f7-list>
                    <f7-list-item popover-close link="#"
                    v-for="item in currencyList"
                    :key="item.id"
                    selected="99"
                    :title="item.code"
                    @click="selectItem('home',item.id, item.code)">
                      
                    </f7-list-item>
                </f7-list>
              </f7-popover>
            </f7-list>
          </div>
          <!-- end of amount field -->

          <!-- OTP -->
          <div class="row no-gap display-flex align-items-center justify-content-space-between">
            <div class="col-25 wandr-otp">QWER</div>
            <div class="col-10">-</div>
            <div class="col-65 text-align-right">
              <f7-list class="form-group">
                <f7-list-input
                  v-for         ="i in 6"
                  :key          ="'otp'+[[i]]"
                  :input-id     ="'otp'+[[i]]"
                  :name         ="'otp'+[[i]]"
                  type          ="tel"
                  class         ="otp"
                  maxlength     ="1"
                  placeholder   =""
                  @input        ="validateOTPForm(i);"
                  autocomplete  ="off"
                  outline
                  required
                >
                </f7-list-input>
              </f7-list>
            </div>
          </div>

          <!-- Home - Transfer In Progress -->
          <div class="b mt-md mb-md">Transfer In Progress</div>
          <div class="wrapper-tx-in-progress">
            <div v-for="tx in txInProgressList" :key="tx.id" class="tx-in-progress card-container" @click="test">
              <div class="card-20">
                <span :class="['badge-'+ tx.statusId, 'badge','mb-md']">{{tx.statusName}}</span>
                <div class="mb-md wandr-level-3 wrap-text">{{tx.beneName}}</div>
                <div class="mb-md">{{tx.txDate}}</div>
                <div class="mb-md wandr-level-3">{{tx.amount}}&nbsp;{{tx.currencyCode}}</div>
              </div>
            </div>
          </div>

          <!-- Quick Send -->
          <div class="b mt-xl">Home - Quick Send</div>
          <f7-list media-list no-hairlines class="beneficiary-list">
            <f7-list-item v-for="bene in beneficiaryList" :key="bene.id" @click="selectBeneficiary(bene.id)" class="card-20">

              <f7-row no-gap class="list-content-row">
                <f7-col class="col-media">
                  <img :src="require('@/assets/img/flags/flag_rect_'+bene.homeCountryId+'.png')" />
                </f7-col>
                <f7-col class="col-details">
                  <div class="wandr-level-3">{{bene.firstName}}</div>
                  <div class="wandr-caption-2">{{bene.dmName}}&nbsp;{{bene.bankAccountNo}}</div>
                </f7-col>
                <f7-col class="text-align-right col-button">
                  <f7-button outline class="" :disabled="false">
                    Send
                  </f7-button>
                </f7-col>
              </f7-row>
              
            </f7-list-item>
          </f7-list>

          <!-- bene list -->
          <div class="b mt-xl mb-md">My Recipients</div>
          <beneListComponent :isSearchBar="true" />
          <!-- end of bene list-->

          <!-- bene card -->
          <div class="b mt-xl mb-md">Recipient</div>
          <div class="card card-20 beneficiary-card display-flex align-items-center justify-content-space-between">
            <div>
              <div class="wandr-level-3">Friends 2</div>
              <div class="wandr-caption-2">BCA (1234567890)</div>
            </div>
            <div class="col-bank">
              <img :src="require('@/assets/img/bank/58.jpg')" style=""/>
            </div>
          </div>

          <div class="b mt-xl mb-md">Recipient </div>
          <div class="card card-20 beneficiary-card display-flex align-items-center justify-content-space-between">
            <div class="col-bank">
              <img :src="require('@/assets/img/bank/58.jpg')" style=""/>
            </div>
            <div class="col-details">
              <div class="wandr-level-3">Friends 2 John Doe Josh Lovuid</div>
              <div class="wandr-caption-2">BCA (1234567890)</div>
            </div>
            <div class="col-country">
              <img :src="require('@/assets/img/flags/flag_circle_small_99.png')"/>
            </div>
          </div>
          <!-- end of bene card-->

          <!-- sheet modal-->
          <!-- apply coupon -->
          <div class="mt-md mb-sm b">Apply Coupon</div>
          <div class="card-container card-coupon">
            <div class="row no-gap display-flex align-items-center" @click="sheetModal.applyCoupon.isOpen = true">
              <div class="col-90 display-flex align-items-center">
                <img :src="require('@/assets/img/icon/icon-discount.svg')" class="mr-sm">
                {{ this.isUseCoupon ? this.selectCouponAmount +" SGD offer applied " : "Apply Offer Code ?"}}
              </div>
              <div class="col-10 chevron right text-align-right"></div>
            </div>
          </div>

          <f7-sheet class="wandr-sheet-modal sheet-24" :opened="sheetModal.applyCoupon.isOpen" @sheet:closed="sheetModal.applyCoupon.isOpen = false" :swipeToClose="true">
            <f7-list class="form-group">
              <f7-list-input
                input-id      ="couponcode"
                name          ="couponcode"
                type          ="text"
                class         ="coupon-code"
                placeholder   ="Enter offer code"
                label         =""
                autocomplete  ="off"
                outline
              >
                <f7-link @click="test" slot="content-end" class="redeem-link">
                  Redeem
                </f7-link>
              </f7-list-input>
            </f7-list>

            <div class="modal-subtitle mb-md">Offer Code</div>
            <div>
              <div>
                <div v-for="cp in couponList" :key="cp.id" class="coupon-list">
                  
                  <div v-if="cp.id == selectCouponId" class="coupon-applied">
                   <div class="text-align-center">
                    <img :src="require('@/assets/img/icon/icon-discount-coupon.svg')" >
                   </div>
                   <div class="text-align-center">Applied</div>
                  </div>

                  <div v-else>
                    <img :src="require('@/assets/img/icon/icon-coupon.svg')" >
                  </div>

                  <div>
                    <div class="wandr-subtitle-2">{{cp.amount}} SGD Offer</div>
                    <div>Valid until {{cp.validdate}}</div>
                  </div>
                  <div>
                    <f7-link v-if="cp.id == selectCouponId" @click="isUseCoupon = false; selectCouponId=0; selectCouponAmount = 0" class="cancel-coupon sheet-close">
                      Cancel
                    </f7-link>
                    <f7-link v-else @click="selectCoupon(cp.id, cp.amount)" class="sheet-close">
                      Use Now
                    </f7-link>
                  </div>
                </div>
              </div>
            </div>
          </f7-sheet>
          <!-- end of sheet modal-->

          <!-- payment summary card -->
          <div class="b mt-xl mb-md">Payment Summary</div>
          <div class="card card-20 payment-summary">
            <div class="mb-20 wandr-level-3">Payment Summary</div>
            <div class="payment-details">
              <div>
                <div>
                  Commision
                  <f7-link popover-open=".popover-commision-info" class="info">
                    <i class="icon f7-icons color-green pl-sm" id="infoCommisionIcon">icon_info_circle</i>
                  </f7-link>
                </div>
                <div>30.00 SGD</div>
              </div>
              <div>
                <div>Convenience Fee</div>
                <div>5.00 SGD</div>
              </div>
            </div>
            <div class="payment-total">
              <div class="wandr-level-3">You Pay</div>
              <div class="wandr-total-amount">35.00 SGD</div>
            </div>
          </div>

          <f7-popover class="popover-commision-info info" :backdrop="true">
            <div class="fs-10 fw-medium">
              Commission may apply for select transfer destinations.
            </div>
          </f7-popover>

          <div class="card card-20 payment-summary">
            <div class="mb-20 wandr-level-3">Transfer To</div>
            <div class="payment-details">
              <div>
                <div>Account Number</div>
                <div>
                  <img :src="require('@/assets/img/icon/icon-copy.svg')" class="mr-sm">
                  100 999 9878
                </div>
              </div>
              <div>
                <div>Company Name</div>
                <div>WANDR PTE LTD</div>
              </div>
            </div>
            <div class="payment-total">
              <div class="wandr-level-3">Total Payable</div>
              <div class="wandr-level-4">
                <img :src="require('@/assets/img/icon/icon-copy.svg')" class="mr-sm">
                35.00 SGD
              </div>
            </div>
          </div>

          <div class="card card-20 payment-summary">
            <div class="mb-20 wandr-level-3">Summary</div>
            <div class="payment-details">
              <div>
                <div>Commision<i class="icon f7-icons color-green pl-sm">icon_info_circle</i></div>
                <div>30.00 SGD</div>
              </div>
              <div>
                <div>Convenience Fee</div>
                <div>5.00 SGD</div>
              </div>
            </div>
            <div class="payment-details pt-sm">
              <div>
                <div>Total amount we'll convert</div>
                <div>120.00 SGD</div>
              </div>
              <div>
                <div>Guaranteed rate (24 hrs)</div>
                <div>1,234.12 SGD</div>
              </div>
            </div>
            <div class="payment-total">
              <div>Should arrive in</div>
              <div>5 hours</div>
            </div>
          </div>
          <!-- end of payment summary card-->

          <!-- Vertical Stepper -->
          <div class="card card-20">
            <ul class="StepProgress">
              <li class="StepProgress-item is-done">
                <div class="tx-progress-title">Transfer created</div>
                <div class="tx-progress-note">Exchange rate SGD/IDR 10,300,00</div>
                <div class="tx-progress-date">11 May 2022 · 12:04</div>
              </li>
              <li class="StepProgress-item current">
                <div class="tx-progress-title">Payment received</div>
              </li>
              <li class="StepProgress-item">
                <div class="tx-progress-title">Post a contest</div>
              </li>
              <li class="StepProgress-item">
                <div class="tx-progress-title">In transit</div>
              </li>
              <li class="StepProgress-item">
                <div class="tx-progress-title">Transfer completed</div>
              </li>
            </ul>
          </div>

          <!-- with bene details -->
          <div class="card card-20">
            <div class="mb-md text-color-gray wandr-level-3">Recipient</div>
            <div class="beneficiary-card display-flex align-items-center justify-content-space-between mb-xl">
              <div class="col-bank">
                <img :src="require('@/assets/img/bank/58.jpg')" style=""/>
              </div>
              <div class="col-details">
                <div class="wandr-level-3">Friends 2 John Doe Josh Lovuid</div>
                <div class="wandr-caption-2">BCA (1234567890)</div>
              </div>
              <div class="col-country">
                <img :src="require('@/assets/img/flags/flag_circle_small_99.png')"/>
              </div>
            </div>

            <ul class="StepProgress">
              <li class="StepProgress-item is-done">
                <div class="tx-progress-title">Transfer created</div>
                <div class="tx-progress-note">Exchange rate SGD/IDR 10,300,00</div>
                <div class="tx-progress-date">11 May 2022 · 12:04</div>
              </li>
              <li class="StepProgress-item current">
                <div class="tx-progress-title">Payment received</div>
              </li>
              <li class="StepProgress-item">
                <div class="tx-progress-title">Post a contest</div>
              </li>
              <li class="StepProgress-item">
                <div class="tx-progress-title">In transit</div>
              </li>
              <li class="StepProgress-item">
                <div class="tx-progress-title">Transfer completed</div>
              </li>
            </ul>
          </div>
          <!-- end of vertical stepper -->

          <!-- Transaction History -->
          <div class="b mt-xl mb-md">Transaction History</div>
          <div>
            <f7-list no-hairlines class="tx-history searchbar-found no-outlines">
              <f7-list-item v-for="item in txInProgressList" :key="item.id"  @click="test()" class="list-content-row">

                <div class="row no-gap w-100">
                  <div class="col-icon">
                    <img :src="require('@/assets/img/icon/icon-money-send.svg')"/>
                  </div>
                  <div class="col-details">
                    <div class="item-title mb-2">{{item.beneName}}</div>
                    <div class="wandr-caption-2" style="">{{item.txDate}}</div>
                  </div>
                  <div class="col-status">
                    <div class="badge mb-2" :class="'badge-'+ item.statusId">{{item.statusName}}</div>
                    <div class="fw-bold">{{item.amount}}&nbsp;{{item.currencyCode}}</div>
                  </div>
                  <div v-if="item.statusId == 10" class=" w-100 display-flex justify-content-end pt-sm" style="border-top:1px solid var(--f7-color-neutral-gray-40)">
                    <f7-button class="mb-sm" fill :disabled="false">Make Payment</f7-button>
                  </div>
                </div>
                
              </f7-list-item>
            </f7-list>
          </div>
          <!-- end of Transaction History -->

          <!-- alert card -->
          <div class="b mt-xl mb-md">Alert Card</div>
          <f7-card
            :title  ="alertCard1.title"
            class  ="alert"
            :class ="alertCard1.alertClass"
            id     ="errorCard"
            v-show ="alertCard1.show"
          >
            <i class="icon f7-icons card-close" @click="alertCard1.show=false">xmark</i>
          </f7-card>
          <br>
          <f7-card
            :title  ="alertCard2.title"
            class  ="alert"
            :class ="alertCard2.alertClass"
            id     ="successCard"
            v-show ="alertCard2.show"
          >
            <i class="icon f7-icons card-close" @click="alertCard2.show=false">xmark</i>
          </f7-card>
          <br>
          <f7-card
            :title  ="alertCard3.title"
            :content="alertCard3.content"
            class  ="alert"
            :class ="alertCard3.alertClass"
            v-show ="alertCard3.show"
          >
            <i class="icon f7-icons card-close" @click="alertCard3.show=false">xmark</i>
          </f7-card>
          <!-- end of alert card -->
          
          <!-- toast -->
          <div class="b mt-xl mb-md" @click="openToastBottom">Click To Open Toast Bottom</div>
          <div class="b mt-xl mb-md" @click="openToastCloseButton">Click To Open Toast With Close Button</div>
          <!-- end of toast -->

          <!-- confirm dialog -->
          <div class="b mt-xl mb-md" @click="openConfirmDialog">Click To Open Confirm Dialog</div>
          <!-- end of confirm dialog -->

          <div class="b mt-xl mb-md">Buttons</div>
          <f7-button class="mb-sm" large fill :disabled="false">Primary</f7-button>
          <f7-button class="mb-sm" large fill :disabled="true">Primary Disabled</f7-button>

          <f7-button class="mb-sm mt-xl color-gray6 text-color-green" large fill :disabled="false">Gray</f7-button>
          <f7-button class="mb-sm color-gray6 text-color-green" large fill :disabled="true">Gray Disabled</f7-button>

          <f7-button large outline class="mb-sm mt-xl" :disabled="false">Primary Outline</f7-button>

          <div class="b mt-xl mb-sm">Horizontal Step Progress</div>
          <div>
            <ul class="step-nav">
              <li class="active"></li>
              <li></li>
              <li></li>
              <li></li>
            </ul>
          </div>

          <div class="b mt-xl mb-sm">Notifications</div>
          <div class="card card-notification">
            <div class="card-content card-content-padding pt-20">
              Transaction #123123 has been cancelled
            </div>
             <div class="card-footer">
              <div>05 July 2022</div>
              <a href="#" class="link">
                See more <i class="f7-icons">chevron_right</i>
              </a>
            </div>
          </div>

          <div class="mt-md mb-sm">Seen Notification</div>
          <div class="card card-notification seen">
            <div class="card-content card-content-padding pt-20">
              Transaction #123123 has been cancelled
            </div>
             <div class="card-footer">
              <div>05 July 2022</div>
              <a href="#" class="link">
                See more <i class="f7-icons">chevron_right</i>
              </a>
            </div>
          </div>

          <!-- NEW NOTIFICATIONS -->
          <f7-list class="list-notif" v-show="true">
            <f7-list-item  @click="test">
                <div class="card card-notification">
                    <div class="notification-subject">Transaction #123123 has been cancelled</div>
                    <div class="card-content">test content of a notification that contains a very looong text hopefully can be displayed all. okay now all seems good. continue to the next step</div> 
                    <div class="card-footer">
                        <div class="notification-date">05 February 2022</div>
                        <a href="#" class="link"><i class="f7-icons">chevron_right</i> </a>
                    </div>
                </div>
            </f7-list-item>
          </f7-list>

          <div class="col-70 text-align-left mb-20">
              <div class="wandr-title-1">{{$t('general-text-notification')}}</div>
          </div>
          <div class="static-content wandre-box">
              <div @click="handleSetTransactionId()" class="notification-subject">Transaction #123123 has been cancelled</div>
              <div class="fs-14 fw-medium" @click="handleSetTransactionId()">test content of a notification that contains a very looong text hopefully can be displayed all. okay now all seems good. continue to the next step</div>

          </div>
          <!-- END OF NEW NOTIFICATIONS-->

          <div class="b mt-xl mb-sm">List Menu</div>
          <div class="card card-20">
            <div class="wandr-level-2">Main Menu</div>
            <f7-list class="list-menu no-border">
              <f7-list-item @click="test" title="Details">
                <div slot="media"><img :src="require('@/assets/img/icon/icon-menu-user.svg')" class="filter-icon"></div>
              </f7-list-item>
              <f7-list-item @click="test" title="FX Alert">
                <div slot="media"><img :src="require('@/assets/img/icon/icon-menu-fx-alert.svg')" class="filter-icon"></div>
              </f7-list-item>
              <f7-list-item @click="test" class="text-color-red logout" title="Logout">
                <div slot="media"><img :src="require('@/assets/img/icon/icon-logout-red.svg')" class=""></div>
              </f7-list-item>
            </f7-list>
          </div>

          <div class="mt-md mb-md">With border</div>
          <div class="card card-20">
            <f7-list class="list-menu">
              <f7-list-item @click="test" title="Details">
                <img slot="media" :src="require('@/assets/img/icon/icon-menu-user.svg')" class="filter-icon">
              </f7-list-item>
              <f7-list-item @click="test" title="Notifications">
                <span slot="after-title" class="badge color-red">5</span>
                <img slot="media" :src="require('@/assets/img/icon/icon-menu-notification.svg')" class="filter-icon">
              </f7-list-item>
              <f7-list-item @click="test" class="text-color-red logout" title="Logout">
                <div slot="media"><img :src="require('@/assets/img/icon/icon-logout-red.svg')" class=""></div>
              </f7-list-item>
            </f7-list>
          </div>

          <div class="card mt-md">
            <f7-list class="list-menu">
              <f7-list-item class="pl-20 pr-20" @click="test" title="Details">
                <div slot="media"><img :src="require('@/assets/img/icon/icon-menu-user.svg')" class="filter-icon"></div>
              </f7-list-item>
            </f7-list>
          </div>

          <div class="b mt-xl mb-md">Invite and Earn</div>
          <div class="card card-18 display-flex align-items-center justify-content-space-between">
            <div class="referal-link">https://referrallink-qwek2a2oawadsdfggshfghsdf</div>
            <div @click="test"><img :src="require('@/assets/img/icon/icon-copy-gray.svg')" class="filter-icon"></div>
          </div>

          <div class="b mt-xl mb-md">Help and Support Menus</div>
          <div id="help-support-container">

            <f7-searchbar search-container="" search-in="" placeholder="Search service" id="help-support-search-bar" class="mb-md"></f7-searchbar>

            <div class="grid" style="">
              <f7-link @click="test" id="square-menu-chat" class="">
                <div><img :src="require('@/assets/img/icon/menu-icon-chat.svg')"></div>
                <div class="">Chat with Maggie</div>
              </f7-link>
              <f7-link @click="test" id="square-menu-faq" class="">
                <div><img :src="require('@/assets/img/icon/menu-icon-faq.svg')"></div>
                <div class="">FAQ</div>
              </f7-link>
              <f7-link @click="test" id="square-menu-news-feed" class="">
                <div><img :src="require('@/assets/img/icon/menu-icon-news-feed.svg')"></div>
                <div class="">News Feed</div>
              </f7-link>
              <f7-link @click="test" id="square-menu-privacy-policy" class="">
                <div><img :src="require('@/assets/img/icon/menu-icon-privacy-policy.svg')"></div>
                <div class="">Privacy Policy</div>
              </f7-link>
              <f7-link @click="test" id="square-menu-tnc" class="">
                <div><img :src="require('@/assets/img/icon/menu-icon-tnc.svg')"></div>
                <div class="">Terms and Conditions</div>
              </f7-link>
            </div>
          </div>

          <div class="b mt-xl mb-md">FAQ</div>
          <div class="list accordion-list" id="faq">
            <f7-searchbar search-container=".faq-list" search-in=".item-title" placeholder="Search FAQ" id="faq-search-bar"></f7-searchbar>

            <f7-list class="searchbar-not-found">
              <f7-list-item title="Nothing found"></f7-list-item>
            </f7-list>

            <ul class="faq-list mt-md">
              <li class="accordion-item">
                <a href="#" class="item-content item-link">
                  <div class="item-inner">
                    <div class="item-title">Lorem Ipsum Dolor Amet?</div>
                  </div>
                </a>
                <div class="accordion-item-content">
                  <div class="block">
                    <p>Item 1 content. Lorem ipsum dolor sit amet...</p>
                  </div>
                </div>
              </li>
              <li class="accordion-item">
                <a href="#" class="item-content item-link">
                  <div class="item-inner">
                    <div class="item-title">How to upload identifications document</div>
                  </div>
                </a>
                <div class="accordion-item-content">
                  <div class="block">
                    <p>Item 2 content. Lorem ipsum dolor sit amet...</p>
                  </div>
                </div>
              </li>
            </ul>
          </div>

          <div class="b mt-xl mb-md">Settings</div>
            <div class="list simple-list no-hairlines-between card card-20 settings-toggle">
              <ul>
                <li>
                  <div class="display-flex align-items-center">
                    <img :src="require('@/assets/img/icon/icon-setting-biometric.svg')" class="mr-sm filter-icon">
                    <span class="item-title">Biometric login</span>
                  </div>
                  <div>
                    <label class="toggle toggle-init color-green2">
                      <input type="checkbox" checked>
                      <span class="toggle-icon"></span>
                    </label>
                  </div>
                </li>
                <li>
                  <div class="display-flex align-items-center">
                    <img :src="require('@/assets/img/icon/icon-setting-face-id.svg')" class="mr-sm filter-icon">
                    <span class="item-title">Face ID</span>
                  </div>
                  <div>
                    <label class="toggle toggle-init color-green2">
                      <input type="checkbox" checked>
                      <span class="toggle-icon"></span>
                    </label>
                  </div>
                </li>
                <li>
                  <div class="display-flex align-items-center">
                    <img :src="require('@/assets/img/icon/icon-setting-dark-mode.svg')" class="mr-sm filter-icon">
                    <span class="item-title">Dark mode</span>
                  </div>
                  <div>
                    <label class="toggle toggle-init color-green2">
                      <input type="checkbox">
                      <span class="toggle-icon"></span>
                    </label>
                  </div>
                </li>
              </ul>
            </div>

            <div class="b mt-xl mb-md">Account Page - My Coupon</div>
            <f7-list class="form-group">
              <f7-list-input
                input-id      ="couponcode2"
                name          ="couponcode2"
                type          ="text"
                class         ="coupon-code"
                placeholder   ="Enter offer code"
                label         =""
                autocomplete  ="off"
                outline
              >
                <f7-link @click="test" slot="content-end" class="redeem-link">
                  Redeem
                </f7-link>
              </f7-list-input>
            </f7-list>

            <div class="list simple-list no-hairlines-between coupon-list">
              <ul>
                <li>
                  <div class="item-title">5 SGD Offer</div>
                  <div class="item-date">Valid until 31 Dec 2022</div>
                </li>
                <li>
                  <div class="item-title">10 SGD Offer</div>
                  <div class="item-date">Valid until 31 Dec 2022</div>
                </li>
                <li>
                  <div class="item-title">15 SGD Offer</div>
                  <div class="item-date">Valid until 31 Dec 2022</div>
                </li>
                <li>
                  <div class="item-title">20 SGD Offer</div>
                  <div class="item-date">Valid until 31 Dec 2022</div>
                </li>
              </ul>
            </div>

            <div class="b mt-xl mb-md">Make Your Payment</div>
            <ul class="make-payment-guide-step">
              <li>Make your payment before : <span>14 July 2022 - 11:00 AM</span></li>
              <li>Save the QR code below & upload to your bank app to make the payment.</li>
            </ul>

        </div>
        <!-- END OF FORM -->

        <!-- send money PhilHealth -->
        <div class="b mt-xl mb-md">Send Money - PhilHealth</div>
        <div class="card card-20">
          <f7-row class="row-with-gap">
            <f7-col>
              <f7-list form class="form-group">
                <f7-list-input
                    input-id     ="year"
                    name         ="year"
                    class        ="clickable-row use-chevron"

                    label       ="Year"
                    placeholder ="Year"
                    :value      ="selectedYear"
                    outline
                    floating-label
                >
                    <f7-link popover-open=".popover-dropdown-year" slot="content-start" class="clickable-item"></f7-link>
                </f7-list-input>

                <f7-popover class="popover-dropdown-year dropdown-default dropdown dropdown-50-left" :backdrop="true">
                  <f7-list>
                      <f7-list-item popover-close link="#"
                      v-for="item in yearList"
                      :key="item.id"
                      selected=""
                      @click="changeYear(item.id);">
                        {{ item.name }}
                      </f7-list-item>
                  </f7-list>
                </f7-popover>
              </f7-list>
            </f7-col>

            <f7-col>
              <f7-list form class="form-group">
                <f7-list-input
                    input-id     ="month"
                    name         ="month"
                    class        ="clickable-row use-chevron"

                    label       ="Month"
                    placeholder ="Month"
                    :value      ="selectedMonth"
                    outline
                    floating-label
                >
                    <f7-link popover-open=".popover-dropdown-month" slot="content-start" class="clickable-item"></f7-link>
                </f7-list-input>

                <f7-popover class="popover-dropdown-month dropdown-default dropdown dropdown-50-right" :backdrop="true">
                  <f7-list>
                      <f7-list-item popover-close link="#"
                      v-for="item in monthList"
                      :key="item.id"
                      selected=""
                      @click="changeMonth(item.id);">
                        {{ item.name }}
                      </f7-list-item>
                  </f7-list>
                </f7-popover>
              </f7-list>
            </f7-col>
          </f7-row>
        </div>
        <!-- end of send money PhilHealth -->

        <!-- login sheet -->
        <div class="b mt-xl mb-md" @click="login.showSheet = true">Clicks to open Login with Fingerprint/FaceID sheet</div>
        <f7-sheet class="wandr-sheet-modal" :opened="login.showSheet" @sheet:closed="login.showSheet = false">
            <f7-block>
              <div class="row no-gap login-with-biometry display-flex justify-content-center align-items-center fs-16 fw-semibold">
                <div class="col selected">Fingerprint</div>
                <div class="col">Face ID</div>
              </div>

              <div
                class="display-flex flex-direction-column justify-content-center mt-xxl mb-xl"
              >
                <img
                  class="biometry-icon"
                  :src="
                    require('@/assets/img/icon/icon-fingerprint.svg')
                  "
                  style="height:100px"
                />
              </div>
            </f7-block>
        </f7-sheet>
        <!-- end of login sheet-->

        <!-- login sheet 2 -->
        <div class="b mt-xl mb-md" @click="login2.showSheet = true">Clicks to open Login with Fingerprint/FaceID sheet 2</div>
        <f7-sheet class="wandr-sheet-modal" :opened="login2.showSheet" @sheet:closed="login2.showSheet = false">
            <f7-block>
              <div class="row no-gap login-with-biometry display-flex justify-content-center align-items-center fs-16 fw-semibold">
                <img
                  class="biometry-icon mr-sm"
                  :src="
                    require('@/assets/img/icon/icon-fingerprint.svg')
                  "
                  style="height:24px"
                />
                Fingerprint
              </div>

              <div
                class="display-flex flex-direction-column justify-content-center mt-xxl mb-xl"
              >
                <img
                  class="biometry-icon"
                  :src="
                    require('@/assets/img/icon/icon-fingerprint.svg')
                  "
                  style="height:100px"
                />
              </div>
            </f7-block>
        </f7-sheet>
        <!-- end of login sheet 2 -->

        <!-- centered screen modal -->
        <div class="b mt-xl mb-md" @click="openModal">Click To Open Modal</div>
        <!-- end of centered screen modal -->

      </div>

      <f7-toolbar position="bottom" no-hairline class="toolbar-with-stacked-button">        
        <f7-button large fill @click="test" :disabled="false">
            Download Invoice
        </f7-button>
        <f7-button class="color-gray6 text-color-green" large fill :disabled="false">
          Back to home
        </f7-button>
      </f7-toolbar>
  </f7-page>
</template>

<script>
  //import langSwitch from '@/components/lang-switch'
  import beneListComponent from '@/components/beneficiary-list'

  export default {    
    mounted (){
      this.init();
    },
    data() {
      return {
        currencyList: [
          {'code': 'SGD', 'id': 189},
          {'code': 'IDR', 'id': 99},
          {'code': 'CNY', 'id': 44}
        ],
        mobileCountryList: [
          {'idd': '+65', 'id': 189, name: 'Singapore'},
          {'idd': '+62', 'id': 99, name: 'Indonesia'},
          {'idd': '+86', 'id': 44, name: 'China'},
          {'idd': '+60', 'id': 128, name: 'Malaysia'},
          {'idd': '+61', 'id': 13, name: 'Australia'},
          {'idd': '+91', 'id': 98, name: 'India'},
          {'idd': '+63', 'id': 167, name: 'Philippines'},
          {'idd': '+66', 'id': 208, name: 'Thailand'},
          {'idd': '+84', 'id': 228, name: 'Vietnam'},
          {'idd': '+64', 'id': 153, name: 'New Zealand'},
          {'idd': '+81', 'id': 106, name: 'Japan'},
          {'idd': '+82', 'id': 111, name: 'Korea, South (KRW)'}
        ],
        paymentPurposeList: [
          {'id': '1', 'name': 'Education'},
          {'id': '2', 'name': 'Saving'},
          {'id': '', 'name': 'Test ID = 0'},
        ],
        pmList: [
          {'id': '1', 'name': 'Pay Now'},
          {'id': '2', 'name': 'Bank Transfer'},
          {'id': '3', 'name': 'Bank Transfer'},
          {'id': '4', 'name': 'Bank Transfer'},
          {'id': '5', 'name': 'Bank Transfer'},
          {'id': '6', 'name': 'Bank Transfer'},
          {'id': '7', 'name': 'Bank Transfer'},
          {'id': '8', 'name': 'Bank Transfer'},
          {'id': '9', 'name': 'Bank Transfer'},
          {'id': '10', 'name': 'Bank Transfer'},
          {'id': '21', 'name': 'Bank Transfer'},
          {'id': '22', 'name': 'Bank Transfer'},
          {'id': '23', 'name': 'Bank Transfer'},
        ],
        paymentPurpose: "",
        paymentPurposeId: 0,
        paymentMethod: "",
        paymentMethod2: "",
        paymentMethodId: 0,
        currentHostId: 189,
        hostCurrCode: "SGD",
        currentHomeId: 44,
        homeCurrCode: "CNY",
        beneficiaryList: [
          {'id': 1, 'homeCountryId': 99, 'homeCurrency' : 'IDR', 'dmId' : 1, 'dmName' : 'Bank Transfer', 'bankId' : 58, 'bankName' : 'Bank A', 'bankAccountNo' : 123456789012345, 'firstName' : 'Josh Lovuid Josh Lovuid Josh Lovuid' },
          {'id': 2, 'homeCountryId': 44, 'homeCurrency' : 'CNY', 'dmId' : 1, 'dmName' : 'Bank Transfer', 'bankId' : 58, 'bankName' : 'Bank B', 'bankAccountNo' : 9801234567, 'firstName' : 'Friends' },
          {'id': 3, 'homeCountryId': 128, 'homeCurrency' : 'MYR', 'dmId' : 1, 'dmName' : 'Bank Transfer', 'bankId' : 58, 'bankName' : 'Bank B', 'bankAccountNo' : 986374658763, 'firstName' : 'Friends 2' }
        ],
        txInProgressList: [
          {'id' : 1, 'beneName' : 'Budi Supriyadi Budi Supriyadi Budi', 'txDate' : '11 May', 'amount' : '999.22', 'currencyCode' : 'SGD', 'statusId' : 35, 'statusName' : 'In Transit'},
          {'id' : 2, 'beneName' : 'Budi Supriyadi', 'txDate' : '11 May', 'amount' : '999.22', 'currencyCode' : 'SGD', 'statusId' : 10, 'statusName' : 'Pending'},
          {'id' : 3, 'beneName' : 'Budi Supriyadi', 'txDate' : '11 May', 'amount' : '999.22', 'currencyCode' : 'SGD', 'statusId' : 40, 'statusName' : 'Completed'},
          {'id' : 4, 'beneName' : 'Budi Supriyadi', 'txDate' : '11 May', 'amount' : '999.22', 'currencyCode' : 'SGD', 'statusId' : 50, 'statusName' : 'Failed'},
          {'id' : 5, 'beneName' : 'Budi Supriyadi', 'txDate' : '11 May', 'amount' : '999.22', 'currencyCode' : 'SGD', 'statusId' : 60, 'statusName' : 'Canceled'},
          {'id' : 5, 'beneName' : 'Budi Supriyadi', 'txDate' : '11 May', 'amount' : '999.22', 'currencyCode' : 'SGD', 'statusId' : 70, 'statusName' : 'Refunded'}
        ],
        couponList: [
          {id: 1, amount: 5, validdate: '31 Dec 2022'},
          {id: 2, amount: 10, validdate: '31 Dec 2022'},
          {id: 3, amount: 15, validdate: '31 Dec 2022'}
        ],
        sheetModal: {
          applyCoupon: { isOpen: false }
        },
        isUseCoupon: false,
        selectCouponId: 0,
        selectedCouponAmount : 0,
        alertCard1: {
          show: true,
          title: "Wrong username or password.",
          content: "",
          alertClass:"alert-danger"
        },
        alertCard2: {
          show: true,
          title: "Your account is ready.",
          content: "",
          alertClass:"alert-success"
        },
        alertCard3: {
          show: true,
          title: "This is alert card title",
          content: "This is he content of alert card. This is he content of alert card. This is he content of alert card.",
          alertClass:"alert-success no-icon"
        },
        mobileNo: "",
        fullname: "",
        selectedYearId: 0,
        selectedYear: "",
        yearList: [
          {id: 2023, name: '2023'},
          {id: 2022, name: '2022'},
          {id: 2021, name: '2021'},
        ],
        selectedMonthId: 0,
        selectedMonth: "",
        monthList: [
          {id: 1, name: 'Jan'},
          {id: 2, name: 'Feb'},
          {id: 3, name: 'Mar'},
          {id: 4, name: 'Apr'},
          {id: 5, name: 'May'},
          {id: 6, name: 'Jun'},
          {id: 7, name: 'Jul'},
          {id: 8, name: 'Aug'},
          {id: 9, name: 'Sep'},
          {id: 10, name: 'Oct'},
          {id: 11, name: 'Nov'},
          {id: 12, name: 'Dec'},
        ],
        login : {
            showSheet     : false,
        },
        login2 : {
            showSheet     : false,
        },
      };
    },
    methods: {
      changeTheme(e){
        let $$ = this.Dom7;
        const el = $$("html");
        e.target.checked
          ? el.addClass("theme-dark")
          : el.removeClass("theme-dark");
      },
      async init(){
        const self               = this;


        var modalContent = '<div class="display-flex justify-content-center mb-xl"><img src='+require('@/assets/img/icon/icon-fingerprint.svg')+' style="height:100px" /></div><div class="pt-md text-align-center fs-14 fw-medium">Dear all,</br></br>Please be informed that due to current activity of volcano eruptions, bank transaction and collection to Indonesia will be affected.</br></br>The banks and collection centers are closed until further notice.</br></br>Thank You</div><div class="mt-xl">';

        self.f7Method = {
          purposeSmartSelect: this.$f7.smartSelect.create({
             el                   : '#purpose-smart-select'
            , openIn              : 'popover'
            , closeOnSelect       : true
            , on                  : {
              open: () => {
                const parentPos = document.getElementById('paymentPurpose').getBoundingClientRect().top;

                var eleWidth = document.getElementById('paymentPurpose').offsetWidth + 1;
                self.$$(".popover.smart-select-popover").css({
                    'margin-top' : ((parentPos+54)-8) + 'px',
                    'width'      : eleWidth + 'px',
                });
              },
              close: () => {
                
              }
            }
          }),

          pmSmartSelect: this.$f7.smartSelect.create({
             el                   : '#pm-smart-select'
            , openIn              : 'popover'
            , cssClass            : 'popover-with-media'
            , closeOnSelect       : true
            , on                  : {
              open: () => {
                const parentPos = document.getElementById('paymentMethod').getBoundingClientRect().bottom;

                var eleWidth = document.getElementById('paymentMethod').offsetWidth +1;
                self.$$(".popover.smart-select-popover").css({
                    'margin-top' : (parentPos - 18) + 'px',
                    'width'      : eleWidth + 'px',
                });

              },
              close: () => {
                
              }
            }
          }),

          // Dropdown with all values
          autocompleteDropdownAll : this.$f7.autocomplete.create({
            inputEl: '#autocomplete-dropdown-all',
            openIn: 'dropdown',
            class: '',
            source: function (query, render) {
              var results = [];
              for (var i = 0; i < self.pmList.length; i++) {
                if (self.pmList[i]['name'].toLowerCase().indexOf(query.toLowerCase()) >= 0) results.push(self.pmList[i]['name']);
              }
              render(results);
            }
          }),

          autocompleteDropdown : this.$f7.autocomplete.create({
            inputEl: '#autocomplete-dropdown',
            openIn: 'dropdown',
            class: '',
            source: function (query, render) {
              var results = [];
              if (query.length === 0) {
                render(results);
                return;
              }
              // Find matched items
              for (var i = 0; i < self.pmList.length; i++) {
                if (self.pmList[i]['name'].toLowerCase().indexOf(query.toLowerCase()) >= 0) results.push(self.pmList[i]['name']);
              }
              // Render items by passing array with result items
              render(results);
            }
          }),

          toastBottom: this.$f7.toast.create({
            text: 'This is default bottom positioned toast',
            closeTimeout: 2000,
          }),

          toastCloseButton: this.$f7.toast.create({
            text: 'Toast with additional close button',
            closeButton: true,
            closeButtonText: 'Dismiss',
          }),
          
          confirmDialog: this.$f7.dialog.create({
            title: 'Do you wish to cancel this money transfer?',
            text: 'Payment received will be refunded to your (based on payment method of user).',
            buttons : [{text: 'Yes', cssClass: 'confirm-yes', onClick: this.test}, {text: 'Back', cssClass: 'confirm-no', onClick: this.test}],
            on: {
              open: function () {
                self.$$('.dialog.dialog-buttons-2').prepend("<span class='close-button'><span>");
              },
              opened: function() {
                self.$$('.dialog.dialog-buttons-2 .close-button').on('click', function () {
                  self.closeConfirmDialog()
                });
              },
              closed: function () {
                self.$$('.dialog.dialog-buttons-2 .close-button').remove();
              }
            }
          }),


          modal1: this.$f7.dialog.create({
            title: '',
            cssClass: 'single-button scrollable-dialog',
            text: modalContent,
            buttons : [{text: 'Dismiss', cssClass: '', onClick: this.test}]
          }),

        },

        self.Dom7('.popover-dropdown-1').on('popover:open', function () {
            self.$$(".popover-dropdown-1").css({
                'visibility' : 'hidden',
            });
        });

        self.Dom7('.popover-dropdown-1').on('popover:opened', function () {     
            var thepopover = self.Dom7('.popover-dropdown-1');
            const classes = thepopover[0].firstChild.classList;
            const popoverDirection = classes[1];

            const parentPosTop = document.getElementById('dropdown1').getBoundingClientRect().top;
            const parentPosBottom = document.getElementById('dropdown1').getBoundingClientRect().bottom;

            var eleHeight = document.querySelector('.popover-dropdown-1 .popover-inner').offsetHeight;

            if(popoverDirection == "on-top"){
              self.$$(".popover-dropdown-1").css({
                  'visibility' : 'visible',
                  'top' : (parentPosBottom + 16) + 'px',
              });
            } else if(popoverDirection == "on-bottom"){
              self.$$(".popover-dropdown-1").css({
                  'visibility' : 'visible',
                  'top' : (parentPosTop - eleHeight - 34) + 'px',
              });
            }
        });

        self.Dom7('.popover-mobile-no-2').on('popover:open', function () {
            self.$$(".popover-mobile-no-2").css({
                'visibility' : 'hidden',
            });
        });

        self.Dom7('.popover-mobile-no-2').on('popover:opened', function () {
            var thepopover = self.Dom7('.popover-mobile-no-2');
            const classes = thepopover[0].firstChild.classList;
            const popoverDirection = classes[1];

            const parentPosTop = document.getElementById('mobileNo2').getBoundingClientRect().top;
            const parentPosBottom = document.getElementById('mobileNo2').getBoundingClientRect().bottom;
            const parentPosLeft = document.getElementById('mobileNo2').getBoundingClientRect().left;
            var eleHeight = document.querySelector('.popover-mobile-no-2 .popover-inner').offsetHeight;

            if(popoverDirection == "on-top"){
              console.log("popover direction: bottom");
              self.$$(".popover-mobile-no-2").css({
                  'visibility' : 'visible',
                  'top' : (parentPosBottom+8) + 'px',
                  'left': (parentPosLeft - 100 - 8) + 'px'
              });
            }else if(popoverDirection == "on-bottom"){
              console.log("popover direction: top");
              self.$$(".popover-mobile-no-2").css({
                  'visibility' : 'visible',
                  'margin-top' : (8) + 'px',
                  'left': (parentPosLeft - 100 - 8) + 'px'
              });
            }else if(popoverDirection == "on-left"){
              console.log("force direction to top");
              console.log("popover direction: left");              
              self.$$(".popover-mobile-no-2").css({ // force direction to top
                  'visibility' : 'visible',
                  'top' : (parentPosTop - eleHeight + 8) + 'px',
                  'left': (24) + 'px'
              });
            }else if(popoverDirection == "on-right"){
              console.log("force direction to top");
              console.log("popover direction: right");            
              self.$$(".popover-mobile-no-2").css({ // force direction to top
                  'visibility' : 'visible',
                  'top' : (parentPosTop - eleHeight + 8) + 'px', /* 8 = padding left of dropdown */
                  'left'  : (parentPosLeft - 100 - 8) + 'px' /* 100 = country code width, 8 = padding left of dropdown */
              });
            }
        });
        
        /*
        // SET DROPDOWN
        const popover = ".sample.popover-mobile-no-2";
        const popoverInner = ".sample.popover-mobile-no-2 .popover-inner";
        const popoverId = "dropdownCountryCode";
        const inputId = "mobileNo2Input";
        const inputListId = "#mobileNo2Input";
        await self.setDropdownDirection(popover, popoverInner, popoverId, inputId, inputListId)
        */

        const popover = ".beneficiary.popover-dropdown-tx-purpose";
        const popoverInner = ".beneficiary.popover-dropdown-tx-purpose .popover-inner";
        const popoverId = "dropdownPaymentPurpose";
        const inputId = "paymentPurpose";
        const inputListId = "#paymentPurposeInput";
        await this.setDropdownDirection(popover, popoverInner, popoverId, inputId, inputListId)


        self.Dom7(".popover-commision-info.info").on('popover:open', function () {
            self.$$(".popover-commision-info.info").css({
                'visibility' : 'hidden',
            });
        });

        self.Dom7(".popover-commision-info.info").on('popover:opened', async function () {
            const parentPosTop = parseFloat(document.getElementById("infoCommisionIcon").getBoundingClientRect().top);
            const parentPosLeft = parseFloat(document.getElementById("infoCommisionIcon").getBoundingClientRect().left);

            var elHeight = parseFloat(self.$$(".popover-commision-info.info.popover.modal-in").height());

            self.$$(".popover.info.modal-in .popover-angle").css({
                'margin-left' : (-9.00 / 2) + 'rem', // 8rem = popover width, 1rem = 16px = margin
                'top' : (elHeight/2) + 'px',
                'transform' : 'rotate(90deg)'
            });

            self.$$(".popover-commision-info.info").css({
                'visibility' : 'visible',
                'left' : (parentPosLeft+40) + 'px',
                'top' : (parentPosTop-16) + 'px'
            });

        });
      },
      openPurposeSmartSelect() {
        this.f7Method.purposeSmartSelect.open()
      },
      changePurpose(selectedId){
        var ppName = this.paymentPurposeList.find(({id})=> id === selectedId).name
        this.paymentPurposeId = selectedId;
        this.paymentPurpose = ppName;
        if(selectedId <= 0){
          this.setInputState("paymentPurpose", "Please enter ref. text/no (eg. Invoice #, Student #, Company Name) to include in the recipient's statement. Note that the reference will only be informed to the beneficiary if the payment system in the destination country allows it to be included. Please indicate the collection point that you would like to collect your remittance from.")
          this.setInputState("dropdown1", "Please enter ref. text/no (eg. Invoice #, Student #, Company Name) to include in the recipient's statement. Note that the reference will only be informed to the beneficiary if the payment system in the destination country allows it to be included. Please indicate the collection point that you would like to collect your remittance from.")
        }
      },
      openPMSmartSelect() {
        this.f7Method.pmSmartSelect.open()
      },
      openToastBottom(){
        this.f7Method.toastBottom.open();
      },
      openToastCloseButton(){
        this.f7Method.toastCloseButton.open();
      },
      openConfirmDialog(){
        this.f7Method.confirmDialog.open();
      },
      closeConfirmDialog(){
        this.f7Method.confirmDialog.close();
      },
      openModal(){
        this.f7Method.modal1.open();
      },
      changePM(selectedId){
        var pmName = this.pmList.find(({id})=> id === selectedId).name
        this.paymentMethodId = selectedId;
        this.paymentMethod = pmName;
      },
      changeYear(selectedId){
        var yearName = this.yearList.find(({id})=> id === selectedId).name
        this.selectedYearId = selectedId;
        this.selectedYear = yearName;
      },
      changeMonth(selectedId){
        var monthName = this.monthList.find(({id})=> id === selectedId).name
        this.selectedMonthId = selectedId;
        this.selectedMonth = monthName;
      },
      openPMPopover() {
        this.f7Method.pmPopover.open()
      },
      validateOTPForm(idx){ 
        var $$ = this.Dom7;

        if($$("#otp"+idx).val().trim() != ""){
          var nextIdx = idx+1;
          if(idx != 6){
            $$("#otp"+nextIdx).focus();
          } 
        }        
      },
      selectItem(field, id, code){
        if(field == "host"){
          this.currentHostId = id;
          this.hostCurrCode = code;
        }else if(field == "home"){
          this.currentHomeId = id;
          this.homeCurrCode = code;
        }
        
      },
      validateInput(e) { 
        if(e.name == "mobileNo"){
          this.setInputState("mobileNo", "Please enter the recipient's home phone number in numerical format phone number in numerical");
          return false;
        }

        var regex = /^[_a-z0-9-]+([_+.a-z0-9-]+)*@[a-z0-9-]+(\.[a-z0-9]+)*(\.[a-z]{2,})$/i
        var validate = regex.test(e.value);
        if(!validate){
          return false;
        }        

        return true;
      },
      selectCoupon(id, amount){
        this.isUseCoupon = true;
        this.selectCouponId = id;
        this.selectCouponAmount = amount;
      },
      test(){
        alert("test")
      },
      searchBarInput(e){
        console.log("searchBarInput: ", e)
      }
    },
    components: {
      //langSwitch,
      beneListComponent
    },
    computed: {
      
    },
  }
</script>